import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DeleteModal from '../DeleteModal';
import useDeleteReminder from '../../../Hooks/reminders/useDeleteReminder';

function DeleteReminderModal({
  id, refetch,
}) {
  const { t } = useTranslation();
  const [isDeleted, setIsDeleted] = useState(false);
  const { mutate: deleteReminder } = useDeleteReminder();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    setIsDeleted(false);
  };
  const handleClose = () => setOpen(false);

  const handleChange = event => {
    event.preventDefault();
    return deleteReminder((id), {
      onSuccess: async () => {
        setIsDeleted(true);
        refetch();
      },
      onError: async () => {
        setIsDeleted(false);
      },
    });
  };

  return (
    <DeleteModal
      deletemodaltitle={t('Delete reminder')}
      deletemodaltext={t('Do you want to delete this reminder')}
      handleChange={handleChange}
      isDeleted={isDeleted}
      setIsDeleted={setIsDeleted}
      deletedText={t('Reminder deleted')}
      open={open}
      handleOpen={handleOpen}
      handleClose={handleClose}
    />
  );
}

DeleteReminderModal.propTypes = {
  id: PropTypes.number,
  refetch: PropTypes.func,
};

export default DeleteReminderModal;
